import * as moment from 'moment'

export class Measure {
    public time: Date
    public value: any

    constructor(opObject: any = null) {
        if (opObject) {
            this.time = new Date(moment.parseZone(opObject.Time).format('YYYY-MM-DDTHH:mm:ss'))
            this.value = opObject.Value           
        }
    }
}